module.exports = __webpack_public_path__ + "img/blockAB42.a32bb2fa.svg";